import OldMainTheme from 'Theme/Main'
import { Themes } from 'Theme/types'

import darkTheme from './Dark'
import defaultTheme from './Default'

const OldTheme = {
  // TODO: Remove after redesign finished
  ...OldMainTheme,
}

const themes: Themes = {
  default: {
    ...OldTheme,
    v2: { ...defaultTheme },
  },
  dark: {
    ...OldTheme,
    v2: { ...darkTheme },
  },
}

export default themes
